import { render } from "./harvesterhci.io.virtualmachineimage.vue?vue&type=template&id=7afb21cc"
import script from "./harvesterhci.io.virtualmachineimage.vue?vue&type=script&lang=js"
export * from "./harvesterhci.io.virtualmachineimage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__